import { _ as __rest } from './tslib.es6-9c37295f.js';
import React__default from 'react';
import { B as BabyGrowthForm } from './index-212a4d98.js';
import { C as CommonGAssets } from './index-d943196d.js';
import { H as HealthToolCardWrapper } from './index-5b8ddf18.js';
import '@mantine/core';
import '@mantine/form';
import './index-3d331313.js';
import '@hhgtech/icons/other';
import '@mantine/hooks';
import './useScreenSize-0f7b1070.js';
import '@emotion/styled';
import './utils-da0db738.js';
import '@mantine/carousel';
import './index-bca4f215.js';
import './other-82ea32cf.js';
import './index-ed3e7858.js';
import './Locale-b74fc19a.js';
import './miscTheme.js';
import './useMantineLocale-69ff962c.js';
import '@mantine/notifications';
import './index-120855f6.js';
import 'date-fns/locale';
import './constantsSite.js';
import './constantsDomainLocales.js';
import './constantsRiskScreener.js';
import './constantsIsProduction.js';
import 'dayjs';
import './index-5b1256a3.js';
import 'classnames';
import './useUniqueId-71ce7077.js';
import '@hhgtech/icons/core';
import './index-3a7b79b6.js';
import '@mantine/dates';
import './index.styles-d00e47f8.js';
import './index-ef9bdc70.js';
import './translationsContext-0bb01e06.js';
import './index-72b06055.js';
import './constants-0b88a6ff.js';
import './index-20490d02.js';
import 'react-keyed-flatten-children';
import './index-6d14ecfd.js';
import './miscDefaultClassWrapper.js';

const BabyGrowthCardEmbed = (_a) => {
    var _b, _c, _d;
    var { babyGrowthContent, formProps } = _a, props = __rest(_a, ["babyGrowthContent", "formProps"]);
    return (React__default.createElement(HealthToolCardWrapper, Object.assign({}, props),
        React__default.createElement(HealthToolCardWrapper.Banner, { icon: React__default.createElement("img", { className: "embedded-icon", alt: "health-tool-icon", src: (babyGrowthContent === null || babyGrowthContent === void 0 ? void 0 : babyGrowthContent.featuredImage) ||
                    CommonGAssets.getAssetPath('health-tools/toolsIconBabyGrowth.svg'), loading: "lazy" }), heading: (babyGrowthContent === null || babyGrowthContent === void 0 ? void 0 : babyGrowthContent.title) || '', medicalReview: {
                link: (_b = babyGrowthContent === null || babyGrowthContent === void 0 ? void 0 : babyGrowthContent.reviewBy) === null || _b === void 0 ? void 0 : _b.link,
                reviewer: (_c = babyGrowthContent === null || babyGrowthContent === void 0 ? void 0 : babyGrowthContent.reviewBy) === null || _c === void 0 ? void 0 : _c.reviewer.trim(),
                date: (_d = babyGrowthContent === null || babyGrowthContent === void 0 ? void 0 : babyGrowthContent.reviewBy) === null || _d === void 0 ? void 0 : _d.date,
            } }),
        React__default.createElement(HealthToolCardWrapper.Body, null,
            React__default.createElement(BabyGrowthForm, Object.assign({}, formProps)))));
};

export { BabyGrowthCardEmbed };
